import axios from "fetch-api/fetch-api";
import PASentry from "../../util/pa-sentry";

export function getMakesByYear(year: number) {
  if (year) {
    return axios.get<string[]>("/get-makes-by-year-v3", {
      params: {
        year,
      },
    });
  }
  const error = new Error("year not present in get-makes-by-year-v3");
  PASentry.logException(error, {}, { });
  return Promise.reject(error);
}
